import { CSS_PREFIX, TABS_MENU_CLASSNAME, ACTIVE_TAB_CLASS_PREFIX, TAB_ITEM_CLASS_PREFIX } from './constants';

export const getActiveTab = (): Element | null => {
  const tabsMenuElement = document.querySelector(`.${CSS_PREFIX}${TABS_MENU_CLASSNAME}`);
  if (!tabsMenuElement) {
    return null;
  }
  const activeTabAttribute = tabsMenuElement.getAttribute('data-state') ?? '';
  const activeTab = activeTabAttribute.replace(ACTIVE_TAB_CLASS_PREFIX, TAB_ITEM_CLASS_PREFIX);
  return activeTab.includes(TAB_ITEM_CLASS_PREFIX) ? document.querySelector(`#${CSS_PREFIX}${activeTab}`) : null;
};
